import styled from "@emotion/styled";
import Colors from "/styles/colors";
export const StyledTemplateLongDescription = styled.div`
  color: ${Colors["mud"]};
  display: flex;
  flex-direction: column;

  .template-description-main-title {
    font-weight: 700;
    font-size: 1rem;
    line-height: 24px;
  }

  .template-paragraph-wrapper {
    font-size: 0.875rem;
    margin-top: 16px;
    max-width: 720px;
    line-height: 24px;
  }

  .template-description-read-more {
    font-size: 0.875rem;
    align-self: flex-start;
    margin: 16px 0;
    color: ${Colors["dodger-blue"]};
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      filter: brightness(85%);
    }
  }
`;
